import { nextFrame } from "../../../library-js/animation/nextFrame";
import { sleep } from "../../../library-js/animation/sleep";
import { LexCode } from "../../../library-js/dom-actions/LexCode";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { CombinedSelector } from "../../../library-js/dom-tools/CombinedSelector";
import { OnChange, OnClick, OnInput, OnMouseDown, OnMouseEnter } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Link } from "../../../library-js/dom-tools/LinkResolver";
import { ClassFilter, MemberDefinitionOrder, SelectedScriptLanguage, VisibleState } from "../../js/cookie-settings/DocSearchSettings";
import { Rokojori } from "../../js/Rokojori";
import { CodeInfo } from "./CodeInfo";
import { MemberInfo } from "./MemberInfo";
import { MembersInfo } from "./MembersInfo";
import { RegExpUtility } from "../../../library-js/text/RegExpUtility";
import { ClassFilterMapping, ClassFilterMappingType, ClassFilterMatcher } from "./ClassFilterMatcher";
import { Enums } from "../../../library-js/tools/Enums";
import { EnumMap } from "../../../library-js/tools/EnumMap";
import { Loader } from "../../../library-js/dom-tools/Loader";
import { ClassInfo } from "./ClassInfo";
import { SortText } from "../../../library-js/text/SortText";
import { LevenshteinDistance, LevenshteinFuzzyMatch } from "../../../library-js/text/Levensthtein";
import { Range } from "../../../library-js/geometry/Range";
import { DOMOrientation } from "../../../library-js/dom/DOMOrientation";
import { MathX } from "../../../library-js/math/MathX";
import { DataTypesLibrary } from "./DataTypesLibrary";
import { waitAround } from "../../../library-js/tools/sleep";
import { GodotSource } from "./GodotSource";
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { RokojoirCookieSettings } from "../../js/cookie-settings/RokojoriCookieSettings";
import { DocSearchIndex, DocSearchIndexItem } from "./DocSearchIndex";
import { GodotDocsVersion } from "../../js/godot-docs/GodotDocsVersion";


export class DocSearch
{
  static readonly type = new ElementType( "doc-search" );
  static readonly content = new ElementType( "doc-search-content" );
  static readonly path = new ElementAttribute( "path" );

  static readonly classesIcon = new ElementType( "doc-search-icon" );
  static readonly classesButton = new ElementType( "doc-search-classes-button" );
  static readonly classesContainer = new ElementType( "doc-search-classes-container" );
  static readonly closeClasses = new ClassFlag( "close-classes" );

  static readonly outlineIcon = new ElementType( "doc-outline-icon" );
  static readonly outlineButton = new ElementType( "doc-search-outline-button" );
  static readonly outlineContainer = new ElementType( "doc-search-outline-container" );
  static readonly closeOutline = new ClassFlag( "close-outline" );
  static readonly members = new ElementType( "doc-members" );

  static readonly languageFlag = new ClassFlag( "language-button" );
  static readonly memberOrderFlag = new ClassFlag( "member-order-button" );
  static readonly filterFlag = new ClassFlag( "filter-button" );
  static readonly viewFlag = new ClassFlag( "view-button" );

  static readonly item = new ElementType( "doc-index-item" );
  static readonly itemTitle = new ElementType( "doc-index-item-title" );
  static readonly itemInheritance = new ElementType( "doc-index-item-inheritance" );

  static readonly searchItem = new ElementType( "doc-search-item" );
  static readonly searchItemIcon = new ElementType( "doc-search-item-icon" );
  static readonly searchItemTitle = new ElementType( "doc-search-item-title" );
  static readonly rawName = new ElementAttribute( "raw-name" );

  static readonly results = new ElementType( "doc-results" );
  static readonly filters = new ElementType( "doc-filters" );
  static readonly input = new ElementType( "doc-search-input" ); 

  static readonly buttonGroup = new ElementType( "button-group" );

  static readonly exportedOnlyCheckbox = new ElementAttribute( "exported-only-checkbox" );
  static readonly viewSelector = new ElementAttribute( "view-selector" );
  static readonly sourcesMatchValue = new ElementAttribute( "-match" );
  static readonly showGodotSources = new AttributeValue( this.sourcesMatchValue, "godot-vanilla" );
  static readonly showRokojoriSources = new AttributeValue( this.sourcesMatchValue,"rokojori" );
  static readonly showGodotDevSources = new AttributeValue( this.sourcesMatchValue,"godot-dev" );

  static isInCookieSettingsChange = false;

  static cachedDocs = new Map<string,DocSearchIndex>();
  static initialized = false; 
  static docSearches:HTMLElement[] = [];

  static filterFunction:(e:Element)=>boolean = null;

  static applyOnDocument()
  {
    DocSearch.docSearches = [];
    DocSearch.type.forAllInDoc( e => DocSearch.applyOnElement( e ) );

    DocSearch.initialize();
  }

  static initialize()
  {
    if ( DocSearch.docSearches.length === 0 || DocSearch.initialized )
    {
      return;
    }

    Rokojori.$.onAnimationFrame.addListener(
      ()=>
      {
        this.docSearches.forEach( ds => DocSearch.updateHeight( ds ) );
        
      }
    )

  }

  static async updateHeight( element:HTMLElement )
  {
    

    if ( DOMOrientation.isPortrait )
    {
      /*
      let ptHeight = window.innerWidth + "px";
      results.style.height = ptHeight;
      members.style.height = ptHeight;

      console.log( "ptHeight:", ptHeight + "" )
      */
      return;
    }

    let results = DocSearch.results.query( element ) as HTMLElement;
    let filters = DocSearch.filters.query( element ) as HTMLElement;
    let members = DocSearch.members.query( element ) as HTMLElement;
   
    let rect = element.getBoundingClientRect();
    let filtersRect = filters.getBoundingClientRect();
    let resultsRect = results.getBoundingClientRect();
    let footer = new ElementType( "rj-footer" );
    
    if ( ! footer )
    {
      // console.log( "No footer", footer);
      return;
    }


    let footerRect = footer.queryDoc().getBoundingClientRect();

    let distance = footerRect.top - rect.top;

    let maxHeight = window.innerHeight - Rokojori.$.landscapeScale.sw * 15;
    let ratio = devicePixelRatio;

   
    
    maxHeight += Math.abs( rect.top - resultsRect.top ) + Rokojori.$.landscapeScale.sw * 4;

    let w = window as any;

    if ( ! w.rj_scale )
    {
      w.rj_scale = 0.9;
    } 

    var scale = 1;

    if ( DOMOrientation.isLandscape && ratio > 1  )
    {
      scale = Math.pow( w.rj_scale, ratio );
      scale = MathX.lerp( 1, scale, ratio - 1 );

      // console.log( "R", ratio, "S", scale, "H", maxHeight );
    }



    let offset = Math.max( maxHeight - distance, 0 );

    let height = `calc( ${scale} * ( 100vh - ( 21 * var( --sw ) + ${offset}px ) ) )`;
    let height2 = `calc( ${scale} * ( 100vh - ( 13.5 * var( --sw ) + ${offset}px ) ) )`;
    //console.log( { height, maxHeight, distance, offset } );
    results.style.height = height;
    members.style.height = height2;
  } 

  static async createDocLinkForType( element:HTMLAnchorElement, type:string = null )
  {
    let href = type + "-class";
    await this.createDocLink( element, href );
    return Promise.resolve();
  } 

  static async createDocLink( element:HTMLAnchorElement, href:string = null )
  {
    let rj = Rokojori.$;
    let ph = rj.pageHandler;
    href = href || ElementAttribute.href.from( element ) ;
    href = href.toLowerCase();

    let originalHref = href;
    let next = ph.normalizePageLink( href );
    let link = Link.Relative( href );
    let rootLink = ph.createRootLink( link );
    href = rootLink.path.replace( /^\:\:\/\//, "" ) + ".php";
    //console.log( "createDocLink", href, link, rootLink );

  
    ElementAttribute.href.to( element, originalHref ); 
    
    OnMouseDown.add( element, ( e:MouseEvent )=>
      { 
        if ( e.button !== 0 )
        {
          return;
        } 

        //console.log( "Removing href", originalHref );
        ElementAttribute.href.removeFrom( element );
      }
    );

    OnMouseEnter.add( element, ( e:MouseEvent )=>
      { 
        //console.log( "Setting href", originalHref );
        ElementAttribute.href.to( element, originalHref );   
      }
    );

    OnClick.add( element,
      async ( ev )=>
      {
        
        setTimeout(
          ()=>
          {
            //console.log( "Setting click delay href", originalHref );
            ElementAttribute.href.to( element, originalHref );
          },
          200
        );

        let codeInfoContainer = CodeInfo.container.queryDoc() as HTMLStyleElement;
        ClassFlag.invisible.set( codeInfoContainer );

        let pageData = await ph.getPage( href );
        await sleep( 100 );
        
        // console.log( href, originalHref, pageData );
        let codeInfo = CodeInfo.type.query( new DOMParser().parseFromString( pageData.rawHTML, "text/html" ).documentElement );        
        let oldCodeInfo = CodeInfo.type.queryDoc();

        if ( codeInfo == null )
        {
          console.log( "Could not find code info:", pageData.rawHTML );
        }

        if ( oldCodeInfo == null )
        {
          console.log( "oldCodeInfo missing" );
        }
        else
        {
          console.log( "Replacing:", oldCodeInfo, codeInfo );
        }

        HTMLEditor.replace( oldCodeInfo, codeInfo );  

        LexCode.applyOnDocument();
        CodeInfo.applyOnElement( codeInfo );

        // DocSearch.addDataTypeReferences();
        DocSearch.processMembers( DocSearch.members.queryDoc() );

        window.scrollTo( 0, 0 );

        await nextFrame();

        ClassFlag.invisible.removeFrom( codeInfoContainer );

        Rokojori.$.pageHandler.setPageWithoutLoading( href );

        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();

        

      }
    );

    return Promise.resolve();
    
  }


  static processMembers( output:Element )
  {
    // console.log( "GET MEMBERS:" ); 
    output.innerHTML = "";

    

    let codeInfo = CodeInfo.type.queryDoc();
    let importingMembers = MemberInfo.memberName.queryAll( codeInfo );

    let classInfo = ClassInfo.type.query( document.documentElement );
    let className = ClassInfo.className.query( classInfo  );

    let isCSOnly = ClassInfo.isCSOnly.in( className ) ;

    let inheritance = ClassInfo.classInheritance.query( codeInfo );

    let anchors = ElementType.anchor.queryAll( inheritance ).filter( a => ! a.hasAttribute( "href" ) );

    if ( anchors.length != 0 )
    {
      anchors.forEach( 
        async ( a ) => 
        {
          await this.processType( a.childNodes[ 0 ], true );
          
          // a.style.textDecoration = "underline";          
          
          
          
        } 
      );
    }

    let membersInfo = MembersInfo.type.create();
    output.appendChild( membersInfo );

    let docSearch = DocSearch.type.getParent( output );
    let outlineContainer = DocSearch.outlineContainer.query( docSearch );

    // console.log( "outlineContainer", codeInfo, outlineContainer );
    let inputContainer = DocSearch.input.query( outlineContainer );
    let input = ElementType.input.query( inputContainer ) as HTMLInputElement;

    let filter = input.value;

    let exportedMembersOnly = Rokojori.$.cookieSettings.ds.exp;

    for ( let i = 0; i < importingMembers.length; i++ )
    {
      let originalMember = importingMembers[ i ];
      let nameSource = originalMember;
      let hasAnchor = false;

      if ( originalMember.childNodes.length > 0 )
      {
        for ( let j = 0; j < originalMember.children.length; j++ )
        {
          if ( ElementType.anchor.is( originalMember.children[ j ] ) )
          {
            nameSource = originalMember.children[ j ];
            hasAnchor = true;
            j = originalMember.children.length;
          }
        }

        
      }

      let originalMemberInfo = MemberInfo.type.getParent( originalMember );

      if ( exportedMembersOnly )
      {
        let isExported = MemberInfo.exportedMember.in( originalMemberInfo );

        if ( ! isExported )
        {
          continue;
        }

      }

      // let isAccessor = ElementAttribute.dataType.from( originalMemberInfo ) == "accessor" || 
      //                  isCSOnly && /^(set_|get_)/.test( originalMember.innerHTML );
      let isAccessor = ( ElementAttribute.dataType.from( originalMemberInfo ) || "" ).indexOf( "accessor" ) != -1; 
  
      if ( isAccessor  )
      {
        let isSet = nameSource.innerHTML.indexOf( "set_" ) != -1; 

        let modifiers = MemberInfo.modifiers.queryAll( originalMemberInfo );

        modifiers.forEach(
          m => 
          {
            let modifiersContent = m.textContent;
        
            let accessorModifier = isSet ? "set" : "get";

            if ( modifiersContent.indexOf( accessorModifier ) == -1 )
            {
              m.innerHTML = modifiersContent + " " + accessorModifier;
            }
          }
        );
        

        ElementAttribute.dataType.to( originalMemberInfo, "accessor " + ( isSet ? "set" : "get" ) );

        nameSource.innerHTML = nameSource.innerHTML.replace( /^(set_|get_)/, "");

        if ( ! hasAnchor )
        {
          CodeInfo.originalMemberName.to( originalMember,  originalMember.innerHTML );
          CodeInfo.lowerCaseMemberName.to( originalMember,  originalMember.innerHTML.toLowerCase() );
        }
      }

      let name = CodeInfo.originalMemberName.from( originalMember ) || "";
      
      
      let memberDataTypes = MemberInfo.dataType.queryAll( originalMemberInfo ) as HTMLElement[];
      let parameterTypes = MemberInfo.parameterType.queryAll( originalMemberInfo ) as HTMLElement[];
      
      

      memberDataTypes.forEach(
        ( dt )=>
        {
          let textNode = dt.childNodes[ dt.childNodes.length - 1 ];
          this.processType( textNode );
        }
      );

      parameterTypes.forEach(
        ( dt )=>
        {
          let textNode = dt.childNodes[ dt.childNodes.length - 1 ];
          this.processType( textNode );
        }
      );

      

      let visible = true;

      if ( filter != null || filter === "" )
      {
        visible = name.toLowerCase().indexOf( filter.toLowerCase() ) != - 1;
      }

      let importingMemberName = originalMember.cloneNode( true ) as Element;
      let memberHeader = MemberInfo.memberHeader.create( importingMemberName );
      let memberInfo = MemberInfo.type.create( memberHeader );

      let dataType = ElementAttribute.dataType.from( MemberInfo.type.getParent( originalMember ) );
      ElementAttribute.dataType.to( memberInfo, dataType );
      membersInfo.appendChild( memberInfo );

      if ( ! visible )
      {
        ClassFlag.hidden.set( memberInfo );
      }

      OnClick.add( memberInfo as HTMLElement,
        async ( me )=>
        {          
          let element = importingMembers.find( m => CodeInfo.originalMemberName.from( m ) === name );

          // console.log( "Scroll into view:", name, element, importingMembers );
          if ( ! element )
          {
            return;
          }

          if ( DOMOrientation.isPortrait )
          {
            let elementPosition = element.getBoundingClientRect().top;
            let headerOffset = new ElementType( "navi-header" ).queryDoc().getBoundingClientRect().height;
            let offsetPosition = elementPosition + window.pageYOffset - headerOffset * 2;

            window.scrollTo(
              
              {
                top: offsetPosition,
                behavior: "smooth"
              }  
            );
          } 
          else
          {
            
            element.scrollIntoView( { behavior: "smooth", block: "center" } );
          }
          
          

          let parent = MemberInfo.type.getParent( element );

          ClassFlag.active.set( parent );

          await sleep( 300 );
          ClassFlag.active.removeFrom( parent );
          await sleep( 100 );
          ClassFlag.active.set( parent );
          await sleep( 300 );
          ClassFlag.active.removeFrom( parent );
        }
      );
    }

  }

  static async processType( textNode:Node, setUnderline:boolean = false )
  {
    if ( textNode == null )
    {
      return;
    }

    await sleep( 100 );
    
    let rawContent = textNode.textContent;
    let replacements = 
    [ 
      "Void", "void",
      "Int32", "int", 
      "Single", "float",
      "Boolean", "bool",
      "String", "string"
    ];

    
    if ( Rokojori.$.cookieSettings != null && Rokojori.$.cookieSettings.ds.t == SelectedScriptLanguage.CSharp )
    {
      let cSharpReplacements = 
      [
        "PackedByteArray","byte[]",
        "PackedColorArray","Color[]",
        "PackedFloat32Array","float[]",
        "PackedFloat64Array","double[]",
        "PackedInt32Array","int[]",
        "PackedInt64Array","long[]",
        "PackedStringArray","string[]",
        "PackedVector2Array", "Vector2[]",
        "PackedVector3Array", "Vector3[]",
        "PackedVector4Array", "Vector4[]"
      ];

      replacements = replacements.concat( cSharpReplacements );
    }
      
    // console.log( "Replacing:", rawContent );
    for ( let i = 0; i < replacements.length; i+=2 )
    {
      if ( rawContent.indexOf( replacements[ i ] ) != -1 )
      {
        let replacementRegex = RegExpUtility.createWordMatcher( replacements[ i ] );
        rawContent = rawContent.replace( replacementRegex, replacements[ i + 1 ] );
      }

      textNode.textContent = rawContent;
    }

    let dataType = textNode.textContent.replace( /\[\]/, "" );
    
    if ( /^List</.test( dataType ) )
    {
      dataType = dataType.replace( /^List</, "" ).replace( />$/, "" );
    }

    dataType = dataType.trim();

    let currentPage = window.location + "";
    
    let docsPath = "en/labs/godot/docs/4.4/";

    if ( currentPage.indexOf( "godot/docs/4.3" ) != -1 )
    {
      docsPath = "en/labs/godot/docs/4.3/";
    }

    let isOld = true;

    if ( GodotDocsVersion.version != "4.4" && GodotDocsVersion.version != "4.3" )
    {
      isOld = false; 
      docsPath = "en/labs/godot/docs/" + GodotDocsVersion.version;
    }
    
    let link = null;

    if ( isOld )
    {
      link = await DataTypesLibrary.getDataTypeLink( dataType, docsPath, Rokojori.$.pageHandler );
    }
    else
    {
      link = await DataTypesLibrary.getDataTypeLinkFromAny( dataType, docsPath, Rokojori.$.pageHandler );
    }

    if ( link == null )
    {
      // console.log( "Type not found:", "is old:", isOld, dataType, "in:", docsPath ); 
      return Promise.resolve();
    }


    let parent = textNode.parentNode as Element;
    let anchor = parent as HTMLAnchorElement;

    if ( ! ElementType.anchor.is( parent ) )
    {
      anchor = ElementType.anchor.create( textNode );
      parent.appendChild( anchor );
    }
    
    
    
    // console.log( parent, anchor, textNode );
    
    await this.createDocLinkForType( anchor, link );

    if ( ! setUnderline || ! anchor.hasAttribute( "href" )  )
    {
      return Promise.resolve();;
    }
   
    anchor.style.textDecoration = "underline";
   
    return Promise.resolve();
    
  }

  static iconLoadersActive = 0;
  static maxIconLoaders = 6;

  static getIconPath( root:string, iconsPath:string, icon:string, matcher:RegExp  )
  {
    let rootLink = Link.Root( root );
    let relativeLink = Rokojori.$.pageHandler.createRelativeLink( rootLink );

    let iconByName = iconsPath + icon + ".svg";    

    let relativeImagePath = relativeLink.path.replace( matcher, iconByName );

    // console.log( "Searching:", relativeImagePath );
    return relativeImagePath;
  }

  static getGodotPath( icon:string )
  {
    // builds/rokojori-com/web/_graphics/labs/godot/icons
    let root ="::/_graphics/labs/godot/icons/Node.svg";
    let iconsPath = "";
    
    return this.getIconPath( root, iconsPath, icon, /\/Node\.svg/ );
  }

  static getRokojoriIcon( icon:string ) 
  {
    let root = "::/_graphics/rokojori-action-library/icons/Action.svg";
    let iconsPath = "";
    
    return this.getIconPath( root, iconsPath, icon, /\/Action\.svg/ );
  }


  static async findIcon( icon:string ):Promise<string>
  {
    let godotIcon = await this.findSpecificIcon( this.getGodotPath( icon ) );

    if ( godotIcon )
    {
      return godotIcon;
    }

    let rokojoriIcon = await this.findSpecificIcon( this.getRokojoriIcon( icon ) );

    if ( rokojoriIcon )
    {
      return rokojoriIcon;
    }

    return null;
  }

  static async searchIcon( iconElement:HTMLElement, item:DocSearchIndexItem )
  { 
    // let rootLink = Link.Root( "::/en/labs/godot/overview.php" );
    // let relativeLink = Rokojori.$.pageHandler.createRelativeLink( rootLink );

    // let iconsPath = "/icons-overview/";
    // let iconByName = iconsPath + item.title + ".svg";    

    // let relativeImagePath = relativeLink.path.replace( /\/overview\.php/, iconByName );

    // console.log( relativeImagePath );

    // let relativeImagePath = this.getIconPath( )

    let imagePath = await this.findIcon( item.title );
 
    if ( imagePath )
    {
      iconElement.style.backgroundImage = `url(${imagePath})`;
      return;
    }

    
    let inheritances = ( [].concat( item.inheritanceStrings ) ).reverse();
    
    for ( let i = 0; i < inheritances.length; i++ )
    {
      let title = inheritances[ i ];
      imagePath = await this.findIcon( title );

      if ( imagePath )
      {
        iconElement.style.backgroundImage = `url(${imagePath})`;
        return;
      }
    }
    

  }

  static async findSpecificIcon( relativeImagePath:string ):Promise<string>
  {
    try
    {
      if ( DocSearch.iconLoadersActive >= DocSearch.iconLoadersActive )
      {
        await nextFrame();
      }

      DocSearch.iconLoadersActive ++;
      let image = await Loader.loadImage( relativeImagePath );
      DocSearch.iconLoadersActive --;

      return Promise.resolve( relativeImagePath );      
    }
    catch ( e )
    {
      DocSearch.iconLoadersActive --;
    }

    return Promise.resolve( null );
  }

  static async applyOnElement( element:Element )
  {
    let path = DocSearch.path.from( element );
    let version = /docs\/(\d+\.\d+)/.exec( path )[ 1 ];

    GodotDocsVersion.version = version;

    console.log( "Version:", `"${path}"`, GodotDocsVersion.version );

    this.docSearches.push( element as HTMLElement );

    let template = Rokojori.$.templatesManager.createTemplate( DocSearch.content.selector );

    element.innerHTML = template.innerHTML; 

    let members = DocSearch.members.query( element );

    let outlineContainer = DocSearch.outlineContainer.query( element );
    let inputContainer = DocSearch.input.query( outlineContainer );    
    let input = ElementType.input.query( inputContainer );

    OnChange.add( input, ()=>{ this.processMembers( members ) });
    OnInput.add( input, ()=>{ this.processMembers( members ) });

    let ds =  Rokojori.$.cookieSettings.ds;

    let viewTypeSelector = DocSearch.viewSelector.query( element ) as HTMLSelectElement;
    viewTypeSelector.selectedIndex = ds.h ? 1 : 0;
    OnChange.add( viewTypeSelector, 
      ( s ) =>
      {       
        if ( DocSearch.isInCookieSettingsChange )
        {
          return;
        }

        Rokojori.$.changeCookieSettings( 
          ( cs )=>
          {
            cs.ds.h = viewTypeSelector.selectedIndex != 0;
          }
        );
      }
    );

    let onCheckBox = ( value:VisibleState, attValue:AttributeValue, callback:( checked:boolean, cs:RokojoirCookieSettings )=>void ) =>
    {
      let checkBox = ElementType.input.query( attValue.query( element ) );
      checkBox.checked = value == VisibleState.Visible;
      OnChange.add( checkBox, 
        ( e )=>
        { 
          if ( DocSearch.isInCookieSettingsChange )
          {
            return;
          }

          Rokojori.$.changeCookieSettings( 
            ( cs )=>
            {
              let checked = checkBox.checked;
              callback( checked, cs );              
            }
          );
        }
      );
    }

    

    onCheckBox( ds.gd, DocSearch.showGodotSources, ( on, cs ) => { cs.ds.gd = on ? VisibleState.Visible : VisibleState.Invisible } );
    onCheckBox( ds.rj,  DocSearch.showRokojoriSources, ( on, cs ) => { cs.ds.rj = on ? VisibleState.Visible : VisibleState.Invisible } );
    onCheckBox( ds.dev, DocSearch.showGodotDevSources, ( on, cs ) => { cs.ds.dev = on ? VisibleState.Visible : VisibleState.Invisible } );


    this.processMembers( members )


    path = path.replace( /^\:\:\//, "" );

    if ( ! path.endsWith( ".php" ) )
    {
      path += ".php";
    }

    let classesButton = DocSearch.classesButton.query( element );

    let classesIcons = DocSearch.classesIcon.queryAll( document.documentElement ) as HTMLElement[];
    let outlineIcons = DocSearch.outlineIcon.queryAll( document.documentElement  ) as HTMLElement[];
    

    let setIconActiveStates = ( classesActive:boolean ) =>
    {
      // console.log( "set state:", classesIcons, outlineIcons );
      classesIcons.forEach( icon => ClassFlag.selected.setAs( icon, classesActive ) );
      outlineIcons.forEach( icon => ClassFlag.selected.setAs( icon, ! classesActive ) );

      
      for ( let i = 0; i < 3; i++ )
      {
        setTimeout( 
          ()=>
          {
            classesIcons.forEach( icon => ClassFlag.selected.setAs( icon, classesActive ) );
            outlineIcons.forEach( icon => ClassFlag.selected.setAs( icon, ! classesActive ) );
          },
          i * 200 
        )
      }
      
    };
    

    let setClasses = ( visible:boolean )=>
    { 
      // setIconActiveStates( true );

      ClassFlag.visible.setAs( DocSearch.classesContainer.query( element ), visible );
      ClassFlag.visible.setAs( classesButton, ! visible );

      if ( DocSearch.isInCookieSettingsChange )
      {
        return;
      }

      Rokojori.$.changeCookieSettings( 
        ( cs )=>
        {
          cs.ds.c = visible ? VisibleState.Visible : VisibleState.Invisible;   

          if ( DOMOrientation.isPortrait && visible )
          {
            cs.ds.o =VisibleState.Invisible;
          }
        }
      );

     
    }

    OnClick.add( classesButton as HTMLElement, 
      ()=>
      { 
        setClasses( true ); 
      }
    );    

    OnClick.add( DocSearch.closeClasses.query( element ) as HTMLElement, ()=>setClasses( false ) ); 


    let outlineButton = DocSearch.outlineButton.query( element );

    let setOutline = ( visible:boolean )=>
    { 
      // setIconActiveStates( false );

      ClassFlag.visible.setAs( DocSearch.outlineContainer.query( element ), visible );
      ClassFlag.visible.setAs( outlineButton, ! visible );

      if ( DocSearch.isInCookieSettingsChange )
      {
        return;
      }

      Rokojori.$.changeCookieSettings( 
        ( cs )=>
        {
          cs.ds.o = visible ? VisibleState.Visible : VisibleState.Invisible;     

          if ( DOMOrientation.isPortrait && visible )
          {
            cs.ds.c =VisibleState.Invisible;
          }
        }
      );

      
    }    

    OnClick.add( outlineButton as HTMLElement, 
      ()=>
      {
        setOutline( true ) 
      }
    );

    
    
    outlineIcons.forEach(
      ( oi )=>
      {
        OnClick.add( oi, ()=> { setClasses( false ); setOutline( true ) }   );
      }
    );
    
    
    classesIcons.forEach(
      ( oi )=>
      {
        OnClick.add( oi, ()=> { setOutline( false ); setClasses( true ) }   );
      }
    )

    let outlineClosingButtons = DocSearch.closeOutline.queryAll( element ) as HTMLElement[];

    outlineClosingButtons.forEach(
      ( ob )=>
      {
        OnClick.add( ob, ()=> setOutline( false) );
      }
    )
   

    if ( ! this.cachedDocs.has( path ) )
    {
      let pageData = await Rokojori.$.pageHandler.getPage( path );
      // console.log( "DocSearch pageData", path, pageData ); 
      let doc = new DOMParser().parseFromString( pageData.rawHTML, "text/html" );
      let items = DocSearch.item.queryAll( doc.documentElement );

      let docSearchIndex = new DocSearchIndex();
      docSearchIndex.items = items.map( 
        it => 
        {
          let item = new DocSearchIndexItem();
          item.title = DocSearch.itemTitle.queryTextContent( it );

          item.title = item.title.replace( /¶/, "" );

          item.link  = ElementType.anchor.query( it ).getAttribute( "href" );

          if ( GodotDocsVersion.version != "4.4" )
          {
            item.link = "../" + item.link;
          }

          // console.log( "link for:", item.title, ">>", `"${item.link}"` );
          item.inheritance = DocSearch.itemInheritance.query( it );

          let icon = ClassInfo.classIcon.query( it );

          if ( ! icon )
          {
            item.icon = "../../icons-overview/No-Icon.svg";
          }
          else
          {
            let style = ElementAttribute.style.from( icon );
            let image = /background\s*\-\s*image\s*\:\s*url\s*\(\s*\"(.+)\"\s*\)/;
            let matched = image.exec( style );

            if ( matched )
            {
              item.icon = matched[ 1 ];

              // console.log( "Found icon:", item.icon );
            }
            else
            {
              console.log( "No icon matched:", style )
            }
            
          }
          
          return item;
        } 
      );

      DocSearch.cachedDocs.set( path, docSearchIndex );

    }

    let docSearchIndex = DocSearch.cachedDocs.get( path );
    let results = DocSearch.results.query( element );
    
    docSearchIndex.items.forEach(
      ( it )=>
      {
        let itemTitle = DocSearch.searchItemTitle.create( it.title );

        DocSearch.rawName.to( itemTitle, it.title );
        
        let icon = DocSearch.searchItemIcon.create() as HTMLElement;
        let anchor = ElementType.anchor.create( [ icon, itemTitle ] );
        ElementAttribute.href.to( anchor, it.link );

        
        let item = DocSearch.searchItem.create( anchor );
        ( item as any )._indexItem = it;

        icon.style.backgroundImage = `url("${it.icon}")`;
        //DocSearch.searchIcon( icon as HTMLElement, it );

        DocSearch.createDocLink( anchor );
        results.appendChild( item );
      }
    )

    let inputElement = ElementType.input.query( element );  

    

    let filterElements = () =>
    {
      let perfectMatches = 0;
      let textValue = inputElement.value.toLowerCase();
      let matcher = RegExpUtility.createMatcher( textValue );
      let highlighter = new ElementType( "highlight-text" );
      let fuzzyHighlighter = new ElementType( "fuzzy-highlight-text" );

      let items = DocSearch.searchItemTitle.queryAll( results );

      let emptyText = textValue === "" || /^\s+$/.test( textValue );

      let settings = Rokojori.$.cookieSettings;
      let activeFilter = settings.ds.cf;
      let classFilter = ClassFilterMatcher.matchers.find( m => m.classFilter === activeFilter );
      let isHierarchyView = settings.ds.h;
      let showGodotSources = VisibleState.Visible == settings.ds.gd;
      let showRokojoriSources = VisibleState.Visible == settings.ds.rj;
      let showDevSources = VisibleState.Visible == settings.ds.dev; 

      // showGodotSources = true;
      // showRokojoriSources = false;

      let filterBySourceType = ( className:string )=>
      {
        let isGodot = GodotSource.hasType( className ) || /@GDScript|@GlobalScope/.test( className );
        let isGodotDev = false;
        let isRokojori = ! isGodot;

        let showing = showGodotSources && isGodot || 
                      showRokojoriSources && isRokojori || 
                      showDevSources && isGodotDev; 
        
        // console.log( { className, showGodotSources, showRokojoriSources, showing, isGodot, isRokojori });
        

        return showing;
      };

      // console.log( "FILTER:", "hier:", isHierarchyView )

      let visibleItems:{parent:Element, item:DocSearchIndexItem}[] = [];

      let minLevel = 10000;
      items.forEach(
        ( it )=>
        {
          HTMLEditor.setText( it, it, DocSearch.rawName.fullName );

          let item = DocSearch.searchItem.getParent( it );
          let indexItem = ( item as any )._indexItem as DocSearchIndexItem;


          let t = it.textContent.toLowerCase();

          let visible = t.indexOf( textValue ) !== -1;

          let parent = DocSearch.searchItem.getParent( it ) as HTMLElement;

          if ( DocSearch.filterFunction )
          {
            visible = visible && DocSearch.filterFunction( parent );
          }
          

          visible = visible && indexItem.isMatching( classFilter );
          visible = visible && filterBySourceType( indexItem.title );



          if ( ! emptyText )
          {
            HTMLEditor.setHighlightedText( it, DocSearch.rawName.from( it ), matcher, highlighter );
          }

          HTMLEditor.setVisibility( parent, visible );

          if ( visible )
          {
            
            visibleItems.push( { parent, item: indexItem } );

            let levels = indexItem.inheritanceStrings.length;
            minLevel = Math.min( levels, minLevel );
            
          }
        }
      );

      if ( visibleItems.length === 0 )
      {
        items.forEach(
          ( it )=>
          {
            HTMLEditor.setText( it, it, DocSearch.rawName.fullName );
  
            let item = DocSearch.searchItem.getParent( it );
            let indexItem = ( item as any )._indexItem as DocSearchIndexItem;
  
  
            let t = it.textContent.toLowerCase();
  
  
            
            let fuzzyMatch = LevenshteinDistance.computeFuzzyMatch( t, textValue );  
            let levenshteinDistance = fuzzyMatch.lowestDistance;
            let visible = levenshteinDistance < textValue.length * 0.4 && levenshteinDistance < 5;
  
  
            let parent = DocSearch.searchItem.getParent( it ) as HTMLElement;
  
            if ( DocSearch.filterFunction )
            {
              visible = visible && DocSearch.filterFunction( parent );
            }
            
  
            visible = visible && indexItem.isMatching( classFilter );
            visible = visible && filterBySourceType( indexItem.title );
  
            if ( ! emptyText )
            {
              let range = new Range( fuzzyMatch.index, fuzzyMatch.index + textValue.length );
              HTMLEditor.setHighlightedTextForRange( it, DocSearch.rawName.from( it ), range, fuzzyHighlighter );
            }
  
            HTMLEditor.setVisibility( parent, visible );
  
            if ( visible )
            {              
              visibleItems.push( { parent, item: indexItem } );
  
              let levels = indexItem.inheritanceStrings.length;
              minLevel = Math.min( levels, minLevel );
              
            }
          }
        );
      }

      if ( isHierarchyView )
      {
        let visibilityIndex = new Map<string,number>();
        let items = new Map<string,DocSearchIndexItem>();
        
        visibleItems.forEach(
          ( v )=>
          {
            visibilityIndex.set( v.item.title, -1 );
            items.set( v.item.title, v.item );

          }
        );

        let resolveVisibilityLevel = ( item:DocSearchIndexItem ) =>
        {
          if ( item == null || ! visibilityIndex.has( item.title ) )
          { 
            return -1;
          }

          let indexValue = visibilityIndex.get( item.title );
          
          if ( indexValue != -1 )
          {
            return indexValue;
          }

          indexValue = 0;

          if ( item.inheritanceStrings.length > 0 )
          {
            let parent = item.inheritanceStrings[ item.inheritanceStrings.length - 1 ];

            if ( visibilityIndex.has( parent ) )
            {
              let parentItem = items.get( parent );
              let parentIndex = resolveVisibilityLevel( parentItem );

              if ( parentIndex != -1 )
              {
                indexValue += parentIndex + 1;
              }
            }

          }

          visibilityIndex.set( item.title, indexValue );

          return indexValue;

        }

        

        visibleItems.forEach(
          ( v )=>
          {
            let parent = v.parent as HTMLElement;
            let levels = Math.max( 0, resolveVisibilityLevel( v.item ) );
            parent.style.paddingLeft = `calc( 0.7em + 0.5em * ${levels} )`;
          }
        )
  
        SortText.sort( visibleItems, ( e ) => e.item.hierarchyName  );  
        visibleItems.forEach( e => HTMLEditor.remove( e.parent ) );
        visibleItems.forEach( e => results.appendChild( e.parent ) );


        // console.log( visibleItems.map( v => v.item.hierarchyName ).join( "\n") );
        
      }
      else
      {
        visibleItems.forEach(
          ( v )=>
          {
            let parent = v.parent as HTMLElement;
            parent.style.paddingLeft = `0.7em`;
          }
        )

        SortText.sort( visibleItems, ( e ) => e.item.title  );

        visibleItems.forEach( e => HTMLEditor.remove( e.parent ) );
        visibleItems.forEach( e => results.appendChild( e.parent ) );
      }

    }

    OnInput.add( inputElement, filterElements );

    let filterButtons  = CombinedSelector.create( DocSearch.classesContainer, DocSearch.filterFlag ).queryAll( element ) as HTMLElement[];

    filterButtons.forEach(
      ( b )=>
      {
        OnClick.add( b,
          async ( c )=>
          {
            ClassFlag.active.setAll( filterButtons, b );
            let classFilterEnumNames = Enums.getNames( ClassFilter );
            let activeClassFilter = RegExpUtility.getClosestMatching( classFilterEnumNames, b.textContent );
            let enumMap = EnumMap.create( ClassFilter );

            if ( DocSearch.isInCookieSettingsChange )
            {
              return;
            }

            Rokojori.$.changeCookieSettings(
              ( cs )=>
              {
                cs.ds.cf = enumMap.namesToKeys.get( activeClassFilter ) as ClassFilter;
              }  
            );

            //filterElements();
          }
        );
      }
    );

    let viewButtons  = CombinedSelector.create( DocSearch.classesContainer, DocSearch.viewFlag ).queryAll( element ) as HTMLElement[];

    viewButtons.forEach(
      ( b )=>
      {
        OnClick.add( b,
          async ( c )=>
          {
            ClassFlag.active.setAll( viewButtons, b );

            if ( DocSearch.isInCookieSettingsChange )
            {
              return;
            }

            Rokojori.$.changeCookieSettings(  
              ( cs )=>
              {
                cs.ds.h = /hierarch/i.test( b.textContent );

                // console.log( cs.ds.h, b.textContent );
              }  
            );
          }
        );
      }
    );

    
    let languageButtons  = CombinedSelector.create( DocSearch.outlineContainer, DocSearch.languageFlag ).queryAll( element ) as HTMLElement[];
      
    let classInfo = ClassInfo.type.query( document.documentElement );
    let className = ClassInfo.className.query( classInfo  );

    let isCSOnly = ClassInfo.isCSOnly.in( className ) ;

    // console.log( "LANG", classInfo, className, isCSOnly );

    let exportedOnlyCheckBox = ElementType.input.query( DocSearch.exportedOnlyCheckbox.query( document.documentElement ) );
    
    OnChange.add( exportedOnlyCheckBox, 
      ()=>
      {
        if ( DocSearch.isInCookieSettingsChange )
        {
          return;
        }

        Rokojori.$.changeCookieSettings(
          ( cs )=>
          {
            cs.ds.exp = exportedOnlyCheckBox.checked;
          }  
        );
      }
    );

    languageButtons.forEach(
      ( b )=>
      {        
        OnClick.add( b,
          ( c )=>
          {
            if ( DocSearch.isInCookieSettingsChange )
            {
              return;
            }

            ClassFlag.active.setAll( languageButtons, b );

            if ( b.textContent === "GDScript" )
            {
              Rokojori.$.changeCookieSettings(
                ( cs )=>
                {
                  cs.ds.t = SelectedScriptLanguage.GDScript;
                }  
              );
            }
            if ( b.textContent === "C#" )
            {
              Rokojori.$.changeCookieSettings(
                ( cs )=>
                {
                  cs.ds.t = SelectedScriptLanguage.CSharp;
                }  
              );
            }

            if ( b.textContent === "Editor" )
              {
                Rokojori.$.changeCookieSettings(
                  ( cs )=>
                  {
                    cs.ds.t = SelectedScriptLanguage.Editor;
                  }  
                );
              }
          }
        );
      }
    );


    let memberOrderButtons  = CombinedSelector.create( DocSearch.outlineContainer, DocSearch.memberOrderFlag ).queryAll( element ) as HTMLElement[];
    
    memberOrderButtons.forEach(
      ( b )=>
      {
        OnClick.add( b,
          ( c )=>
          {
            if ( DocSearch.isInCookieSettingsChange )
            {
              return;
            }

            ClassFlag.active.setAll( memberOrderButtons, b );

            if ( b.textContent.indexOf( ":" ) !== -1 )
            {
              Rokojori.$.changeCookieSettings(
                ( cs )=>
                {
                  cs.ds.md = MemberDefinitionOrder.NameType;
                }  
              );
            }
            else 
            {
              Rokojori.$.changeCookieSettings(
                ( cs )=>
                {
                  cs.ds.md = MemberDefinitionOrder.TypeName;
                }  
              );
            }
          }
        );
      }
    );

    //filterElements();

    Rokojori.$.onCookieSettings( 
      ( cs )=>
      {
        DocSearch.isInCookieSettingsChange = true;

        let ds = cs.ds;

        setClasses( ds.c === VisibleState.Visible );
        setOutline( ds.o === VisibleState.Visible );

        let exportedOnlyCheckBox = ElementType.input.query( DocSearch.exportedOnlyCheckbox.query( document.documentElement ) );
        
        exportedOnlyCheckBox.checked = ds.exp;
        
        let classesIcons = DocSearch.classesIcon.queryAll( document.documentElement ) as HTMLElement[];
        let outlineIcons = DocSearch.outlineIcon.queryAll( document.documentElement  ) as HTMLElement[];
        
        let classesActive = ds.c == VisibleState.Visible;
        classesIcons.forEach( icon => ClassFlag.selected.setAs( icon, classesActive ) );
        outlineIcons.forEach( icon => ClassFlag.selected.setAs( icon, ! classesActive ) );

        viewTypeSelector.selectedIndex = ds.h ? 1 : 0;

        ElementType.input.query( DocSearch.showGodotSources.query( element ) ).checked = 
          ds.gd == VisibleState.Visible;
        ElementType.input.query( DocSearch.showRokojoriSources.query( element ) ).checked = 
          ds.rj == VisibleState.Visible;
        ElementType.input.query( DocSearch.showGodotDevSources.query( element ) ).checked = 
          ds.dev == VisibleState.Visible;

        
        let ro = new ElementType( "rokojori-only" );
        let roElement = ro.queryDoc() as HTMLElement;
          roElement.style.display = ds.rj == VisibleState.Visible ? "inline" : "none";
        

        let ss = ds.t;
        let scriptButton:Element;

        let mappings = 
        [ 
          { type: SelectedScriptLanguage.CSharp, value:"C#" },
          { type: SelectedScriptLanguage.GDScript, value:"GDScript" },
          { type: SelectedScriptLanguage.Editor, value:"Editor" }
        ]

        let value = mappings.find( m => m.type === ss ).value;
        
        scriptButton = languageButtons.find( b => b.textContent === value );  

        let codeInfo = CodeInfo.type.queryDoc();

        let orderButton = memberOrderButtons.find( b => b.textContent.indexOf( ":" ) === -1 );

        if ( ds.md === MemberDefinitionOrder.TypeName )
        {
          MembersInfo.tnStyle.set( codeInfo );
          MembersInfo.ntStyle.removeFrom( codeInfo );
        }
        else
        {
          orderButton = memberOrderButtons.find( b => b.textContent.indexOf( ":" ) !== -1 );
          MembersInfo.tnStyle.removeFrom( codeInfo );
          MembersInfo.ntStyle.set( codeInfo );
        }

        let classFilterType   =  ClassFilter[ ds.cf ];
       
        let activeClassFilter = RegExpUtility.getClosestMatching( filterButtons, classFilterType, c => c.textContent );
        let activeView = viewButtons.find( v => ds.h ? /hier/i.test( v.textContent ) : /flat/i.test( v.textContent ));

        // console.log( "Current Class Filter:", ds.cf, classFilterType, activeClassFilter );
        ClassFlag.active.setAll( filterButtons, activeClassFilter );
        ClassFlag.active.setAll( viewButtons, activeView );
        ClassFlag.active.setAll( languageButtons, scriptButton );
        ClassFlag.active.setAll( memberOrderButtons, orderButton );

        filterElements();

        DocSearch.processMembers( DocSearch.members.queryDoc() );

        DocSearch.isInCookieSettingsChange = false;
      }
    );

    
  }

  
}